<script setup lang="ts">
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectSeparator, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Search } from 'lucide-vue-next'

interface FilterForm {
    email_fullname: string
    order_id: string
    ticket_category: string
    order_payment_type: string
    order_status: string
    mailing_group: string
    mailing_status: string
    mailing_code: string
}

defineProps<{
    form: FilterForm
}>()
</script>

<template>
    <form class="grid gap-x-6 gap-y-4 lg:grid-cols-4">
        <div class="relative w-full items-center">
            <Input id="search" type="text" placeholder="Pesquisar por nome ou e-mail" class="pl-8" v-model="form.email_fullname" />
            <span class="absolute inset-y-0 start-0 flex items-center justify-center px-2">
                <Search class="text-muted-foreground size-5" />
            </span>
        </div>

        <div>
            <Input type="number" placeholder="Número do pedido" v-model="form.order_id" />
        </div>

        <div>
            <Select class="w-full" v-model="form.ticket_category">
                <SelectTrigger class="w-full">
                    <SelectValue placeholder="Tipo de ingresso" />
                </SelectTrigger>

                <SelectContent>
                    <SelectItem :value="null">Tipo do ingresso</SelectItem>
                    <SelectSeparator />
                    <SelectItem value="digital">Palestras Gravadas</SelectItem>
                    <SelectItem value="full_content">Conteúdo Total</SelectItem>
                    <SelectItem value="full_pass">Full pass</SelectItem>
                </SelectContent>
            </Select>
        </div>

        <div>
            <Select class="w-full" v-model="form.mailing_status">
                <SelectTrigger class="w-full">
                    <SelectValue placeholder="Status do ingresso" />
                </SelectTrigger>

                <SelectContent>
                    <SelectItem :value="null">Status do ingresso</SelectItem>
                    <SelectSeparator />
                    <SelectItem value="ticket_generated">Ingresso gerado</SelectItem>
                    <SelectItem value="invited">Preenchimento pendente</SelectItem>
                    <SelectItem value="canceled">Convite revogado</SelectItem>
                    <SelectItem value="canceled_by_order">Cancelado</SelectItem>
                </SelectContent>
            </Select>
        </div>
        <div>
            <Select class="w-full" v-model="form.mailing_group">
                <SelectTrigger class="w-full">
                    <SelectValue placeholder="Grupo do ingresso" />
                </SelectTrigger>

                <SelectContent>
                    <SelectItem :value="null">Grupo do ingresso</SelectItem>
                    <SelectSeparator />
                    <SelectItem value="purchased_ticket">Comprado</SelectItem>
                    <SelectItem value="speaker">Palestrante</SelectItem>
                    <SelectItem value="sponsor">Patrocinador</SelectItem>
                    <SelectItem value="summit_access">Acesso ao Summit</SelectItem>
                    <SelectItem value="press">Imprensa</SelectItem>
                    <SelectItem value="production">Produção</SelectItem>
                    <SelectItem value="exhibitor">Expositor</SelectItem>
                    <SelectItem value="courtesy">Cortesia</SelectItem>
                    <SelectItem value="staff">Equipe</SelectItem>
                    <SelectItem value="supporter">Apoiador</SelectItem>
                    <SelectItem value="guest">Convidado</SelectItem>
                </SelectContent>
            </Select>
        </div>
        <div>
            <Select class="w-full" v-model="form.order_payment_type">
                <SelectTrigger class="w-full">
                    <SelectValue placeholder="Método de pagamento" />
                </SelectTrigger>

                <SelectContent>
                    <SelectItem :value="null">Método de pagamento</SelectItem>
                    <SelectSeparator />
                    <SelectItem value="pix">PIX</SelectItem>
                    <SelectItem value="credit_card">Cartão de crédito</SelectItem>
                    <SelectItem value="bank_slip">Boleto bancário</SelectItem>
                    <SelectItem value="company_billing">Faturamento CNPJ</SelectItem>
                    <SelectItem value="paypal">Paypal</SelectItem>
                </SelectContent>
            </Select>
        </div>
        <div>
            <Select class="w-full" v-model="form.order_status">
                <SelectTrigger class="w-full">
                    <SelectValue placeholder="Status do pedido" />
                </SelectTrigger>

                <SelectContent>
                    <SelectItem :value="null">Status do pedido</SelectItem>
                    <SelectSeparator />
                    <SelectItem value="pending">Pendente</SelectItem>
                    <SelectItem value="paid">Pago</SelectItem>
                    <SelectItem :value="['canceled', 'refunded']">Cancelado</SelectItem>
                    <SelectItem value="released">Liberado</SelectItem>
                    <SelectItem value="canceled_by_admin">Cancelado pelo Administrador</SelectItem>
                </SelectContent>
            </Select>
        </div>

        <div>
            <Input type="text" placeholder="Código do ingresso" v-model="form.mailing_code" />
        </div>
    </form>
</template>
